// Giữ lead gửi lỗi (mạng / máy chủ) trên trình duyệt và tự gửi lại lần sau (YC-TOOL-09, HT-06 D-01, D-02).
// Mỗi công cụ dùng một khóa localStorage riêng; chỉ giữ lead gần nhất của công cụ đó.

/** Lưu lead chưa gửi được. Lỗi localStorage (chế độ ẩn danh, đầy bộ nhớ) thì bỏ qua. */
export function savePendingLead(storageKey, payload) {
  try {
    localStorage.setItem(storageKey, JSON.stringify(payload));
  } catch (e) {
    // bỏ qua
  }
}

/** Xóa lead đang chờ (sau khi gửi thành công). */
export function clearPendingLead(storageKey) {
  try {
    localStorage.removeItem(storageKey);
  } catch (e) {
    // bỏ qua
  }
}

/**
 * Gửi lại lead đang chờ (nếu có) bằng hàm `send(payload)`.
 * Thành công hoặc dữ liệu sai (400, gửi lại cũng không được) thì xóa; lỗi khác giữ để lần sau gửi tiếp.
 */
export async function resendPendingLead(storageKey, send) {
  let pending = null;
  try {
    pending = JSON.parse(localStorage.getItem(storageKey) || 'null');
  } catch (e) {
    pending = null;
  }
  if (!pending) return;
  try {
    await send(pending);
    clearPendingLead(storageKey);
  } catch (err) {
    if (err?.statusCode === 400) clearPendingLead(storageKey);
  }
}
